(function () {
  var wishlistIconTpl = null;
  var wdSwymRetryTimer = null;
  var wdSwymInitDone = false;

  function getWishlistIconHtml() {
    if (wishlistIconTpl !== null) return wishlistIconTpl;
    var tpl = document.getElementById('wd-cpcard-wishlist-icon-tpl');
    wishlistIconTpl = tpl ? tpl.innerHTML.trim() : '';
    return wishlistIconTpl;
  }

  function patchWdCollectionWishlistButtons() {
    var iconHtml = getWishlistIconHtml();
    document
      .querySelectorAll('.section--wd-collection-pcard .wd-collection-pcard__wishlist button.swym-button')
      .forEach(function (btn) {
        btn.querySelectorAll('.swym-heart').forEach(function (node) {
          node.remove();
        });
        if (!btn.querySelector('.wd-collection-pcard__wishlist-icon') && iconHtml) {
          btn.insertAdjacentHTML('afterbegin', iconHtml);
        }
        btn.style.color = '#505cd2';
      });
  }

  function initSwymCollectionWishlist() {
    if (wdSwymInitDone || wdSwymRetryTimer !== null) return;

    document.dispatchEvent(new CustomEvent('swym:collections-loaded'));

    function run() {
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons();
        patchWdCollectionWishlistButtons();
        window.setTimeout(patchWdCollectionWishlistButtons, 0);
        window.setTimeout(patchWdCollectionWishlistButtons, 150);
        wdSwymInitDone = true;
        return true;
      }
      return false;
    }

    if (run()) return;

    var tries = 0;
    wdSwymRetryTimer = window.setInterval(function () {
      tries += 1;
      if (run() || tries >= 24) {
        if (tries >= 24) patchWdCollectionWishlistButtons();
        window.clearInterval(wdSwymRetryTimer);
        wdSwymRetryTimer = null;
        if (run()) wdSwymInitDone = true;
      }
    }, 250);
  }

  function closeTieredInRoot(root) {
    if (!root) return;
    var btn = root.querySelector('[data-wd-tiered-toggle]');
    var panel = root.querySelector('[data-wd-tiered-panel]');
    if (btn && panel) {
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }
  }

  function closeAllTiered(exceptRoot) {
    document.querySelectorAll('[data-wd-collection-pcard]').forEach(function (root) {
      if (exceptRoot && root === exceptRoot) return;
      closeTieredInRoot(root);
    });
  }

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-wd-tiered-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeTieredInRoot(closeBtn.closest('[data-wd-collection-pcard]'));
      return;
    }

    var toggle = e.target.closest('[data-wd-tiered-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var root = toggle.closest('[data-wd-collection-pcard]');
      var panel = root && root.querySelector('[data-wd-tiered-panel]');
      if (!panel) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      if (open) {
        closeTieredInRoot(root);
      } else {
        closeAllTiered();
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
      return;
    }

    if (!e.target.closest('[data-wd-tiered-toggle]') && !e.target.closest('[data-wd-tiered-panel]')) {
      closeAllTiered();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllTiered();
  });

  if (document.querySelector('.section--wd-collection-pcard')) {
    document.addEventListener('DOMContentLoaded', initSwymCollectionWishlist);
    if (document.readyState !== 'loading') {
      initSwymCollectionWishlist();
    }
    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, initSwymCollectionWishlist);
    }
  }

  // Row-by-row title equalizer: in each visual row, set every title's min-height
  // to the tallest natural title height in that row. Rows where no title wraps
  // stay at 1 line; rows where one title wraps to 2 lines push the row's other
  // titles to 2 lines so prices/swatches align horizontally.
  var equalizeRaf = null;
  function equalizeRowTitles() {
    var scopes = document.querySelectorAll('.section--wd-collection-pcard');
    if (!scopes.length) return;
    scopes.forEach(function (scope) {
      var titles = scope.querySelectorAll('.wd-collection-pcard__title');
      if (!titles.length) return;

      for (var i = 0; i < titles.length; i++) titles[i].style.minHeight = '';

      var rows = {};
      for (var j = 0; j < titles.length; j++) {
        var rect = titles[j].getBoundingClientRect();
        var key = Math.round(rect.top);
        if (!rows[key]) rows[key] = [];
        rows[key].push(titles[j]);
      }

      Object.keys(rows).forEach(function (key) {
        var group = rows[key];
        var max = 0;
        for (var k = 0; k < group.length; k++) {
          var h = group[k].offsetHeight;
          if (h > max) max = h;
        }
        if (max > 0) {
          for (var m = 0; m < group.length; m++) group[m].style.minHeight = max + 'px';
        }
      });
    });
  }

  function scheduleEqualize() {
    if (equalizeRaf) cancelAnimationFrame(equalizeRaf);
    equalizeRaf = requestAnimationFrame(function () {
      equalizeRaf = null;
      equalizeRowTitles();
    });
  }
  window.productRowScheduleEqualize = scheduleEqualize

  function initRowEqualizer() {
    if (!document.querySelector('.section--wd-collection-pcard')) return;

    scheduleEqualize();
    window.addEventListener('load', scheduleEqualize);

    var resizeT = null;
    window.addEventListener('resize', function () {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(scheduleEqualize, 100);
    });

    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, scheduleEqualize);
    }

    document
      .querySelectorAll('.section--wd-collection-pcard #ProductsList, .section--wd-collection-pcard .grid-list')
      .forEach(function (grid) {
        var mo = new MutationObserver(scheduleEqualize);
        mo.observe(grid, { childList: true });
      });

    document
      .querySelectorAll('.section--wd-collection-pcard .wd-collection-pcard__img')
      .forEach(function (img) {
        if (!img.complete) img.addEventListener('load', scheduleEqualize, { once: true });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRowEqualizer);
  } else {
    initRowEqualizer();
  }
})();
